import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { CustomList } from "components";
import { useMilestone } from "@/modules/work/milestones/context";
import { EmployeeCell } from "components/cell/employee/cell";
import { HoursCell, TotalHoursCell } from "@/components/hours/cell";

export default function MilestoneEmployeeTimesheet() {
  const [totals, setTotals] = useState(null);

  const { milestoneId: paramMilestoneId } = useParams();
  const { job, project, type, milestoneId: ctxMilestoneId } = useMilestone();

  const milestoneId = ctxMilestoneId || paramMilestoneId;
  const jobId = job?.id;
  const projectId = project?.id;
  const isFixedOrDedicated = ["fixed", "dedicated"].includes(type);

  const columns = [
    {
      id: "employee",
      accessorKey: "employee",
      header: "Employee",
      cell: EmployeeCell,
      footer: "Total",
    },
    {
      id: "department",
      accessorKey: "department",
      header: "Department",
      cell: ({ getValue }) => <span className="capitalize">{getValue()?.name}</span>,
    },
    {
      id: "logged",
      accessorKey: "logged",
      header: "Logged",
      cell: HoursCell,
      footer: TotalHoursCell("logged"),
    },

    ...(isFixedOrDedicated
      ? [
          {
            id: "spent",
            accessorKey: "spent",
            header: "Spent",
            cell: HoursCell,
            footer: TotalHoursCell("spent"),
          },
        ]
      : []),
    {
      id: "approved",
      accessorKey: "approved",
      header: "Approved",
      cell: HoursCell,
      footer: TotalHoursCell("approved"),
    },
    ...(isFixedOrDedicated
      ? [
          {
            id: "consumed",
            accessorKey: "consumed",
            header: "Consumed",
            cell: HoursCell,
            footer: TotalHoursCell("consumed"),
          },
        ]
      : []),
    {
      id: "unreviewed",
      accessorKey: "unreviewed",
      header: "Unreviewed",
      cell: HoursCell,
      footer: TotalHoursCell("unreviewed"),
    },
  ];

  const defaultFilters = {
    jobId,
    milestoneId,
    projectId,
  };

  if (!projectId || !jobId || !milestoneId) return null;

  return (
    <div className="flex-1 overflow-auto" key={`${jobId}-${projectId}-${milestoneId}`}>
      <CustomList
        storageKey={`${jobId}-${projectId}-${milestoneId}`}
        title="Employees"
        endPoint="custom-ui/get-employee-wise-timesheet-summary-for-project"
        filters={defaultFilters}
        columns={columns}
        hidePagination={true}
        onDataChange={(response) => setTotals(response.meta?.totals)}
      />
    </div>
  );
}
